// ============================================================
// useGlobalErrorTracker — Hook per intercettare eccezioni JS
// non gestite ed eventuali rejection di Promise non gestite,
// a livello globale (window), e loggarle via OTel.
//
// Deve essere montato una volta sola, idealmente nel componente
// App, accanto a useSessionTracker.
// ============================================================

import { useEffect } from 'react';
import { trackGlobalError } from './otelExporter';

export default function useGlobalErrorTracker() {
  useEffect(() => {
    const handleError = (event) => {
      const message = (event && event.error && event.error.message) || (event && event.message) || 'unknown error';
      const stack = event && event.error && event.error.stack;
      // filename/lineno/colno: il punto esatto dove è stata lanciata l'eccezione.
      // Sono l'unica informazione che identifica gli script iniettati a runtime
      // (tag manager, vendor): nei loro stack compare l'URL del documento, non del file.
      trackGlobalError(message, 'window.onerror', stack, {
        filename: event && event.filename,
        lineno: event && event.lineno,
        colno: event && event.colno,
        errorName: event && event.error && event.error.name,
      });
    };

    const handleRejection = (event) => {
      const reason = event && event.reason;
      const message = (reason && reason.message) || String(reason || 'unhandled rejection');
      const stack = reason && reason.stack;
      // una rejection non porta filename/lineno/colno: solo il nome dell'errore
      trackGlobalError(message, 'unhandledrejection', stack, {
        errorName: reason && reason.name,
      });
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, []);
}
